<template>
  <div class="home-container">
    <!-- 侧边栏 -->
    <aside class="sidebar">
      <div class="logo-container">
        <img src="@/assets/logo.png"
             alt="Logo"
             class="logo">
      </div>
      <div class="nav-menu">
        <div class="nav-item"
             v-for="(item, index) in navItems"
             :key="index"
             @click="navigateTo(item.path)"
             :class="{active: currentNavName === item.name}">
          <img :src="item.icon" class="nav-icon" alt="菜单图标">
          <span>{{ item.name }}</span>
        </div>
      </div>
    </aside>

    <div class="main-area">
      <!-- 头部导航栏 -->
      <header class="header">
        <div class="header-content">
          <div class="current-nav">
            <h2>{{ currentNavName }}</h2>
          </div>
          <div class="user-info" @click="toggleDropdown">
            <div class="avatar">
              <img src="@/assets/default-avatar.svg"
                   alt="用户头像"
                   onerror="this.src='https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'">
            </div>
            <span class="username">{{ username }}</span>
            <i class="el-icon-arrow-down" style="margin-left: 5px;"></i>
            
            <!-- 退出登录下拉菜单 -->
            <div class="dropdown-menu" v-show="showDropdown" @click.stop>
              <div class="dropdown-item" @click.stop="logout">
                <i class="el-icon-switch-button"></i>
                <span>退出登录</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <!-- 主内容区域 -->
      <main class="content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { getUserProfile } from '@/api/profile';

export default {
  name: 'HomePage',
  data() {
    return {
      username: '',
      currentNavName: '', // 将在created钩子中设置
      showDropdown: false, // 控制下拉菜单显示
      navItems: [
        { name: '发布产品', path: '/publish', icon: require('@/assets/icon_publish.png') },
        { name: '任务审核', path: '/tasks', icon: require('@/assets/icon_tasks.png') },
        { name: '设备监控', path: '/devices', icon: require('@/assets/icon_devices.png') },
        { name: '实时监控', path: '/realtime', icon: require('@/assets/icon_realtime.png') },
        { name: '设备预警', path: '/alerts', icon: require('@/assets/icon_alerts.png') },
        { name: '维修报修', path: '/maintenance', icon: require('@/assets/icon_maintenance.png') },
        { name: '大屏看板', path: '/dashboard', icon: require('@/assets/icon_dashboard.png') },
        { name: '产品中心', path: '/products', icon: require('@/assets/icon_products.png') },
        { name: '个人信息', path: '/profile', icon: require('@/assets/icon_profile.png') },
        { name: '反馈中心', path: '/feedback', icon: require('@/assets/icon_feedback.png') }
      ]
    }
  },
  created() {
    // 根据当前路由路径设置导航项名称
    this.updateNavName(this.$route.path);
    
    // 获取用户信息
    this.getUserInfo();
    
    // 添加点击页面其他区域关闭下拉菜单的事件监听
    document.addEventListener('click', this.closeDropdown);
  },
  
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener('click', this.closeDropdown);
  },
  watch: {
    // 监听路由变化
    '$route.path'(newPath) {
      this.updateNavName(newPath);
    }
  },
  methods: {
    updateNavName(path) {
      // 根据路径更新导航项名称
      const navItem = this.navItems.find(item => item.path === path);
      if (navItem) {
        this.currentNavName = navItem.name;
      } else {
        // 如果没有匹配的导航项，默认使用第一个
        this.currentNavName = this.navItems[0].name;
      }
    },
    navigateTo(path) {
      // 更新当前导航项名称
      this.updateNavName(path);
      // 如果当前已经在该路径，不进行跳转
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    // 切换下拉菜单显示状态
    toggleDropdown(event) {
      event.stopPropagation(); // 阻止事件冒泡
      this.showDropdown = !this.showDropdown;
    },
    // 退出登录
    logout(event) {
      event.stopPropagation(); // 阻止事件冒泡
      this.$confirm('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除登录状态
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('tokenExpiration');
        
        // 提示退出成功
        this.$message.success('退出登录成功');
        
        // 使用replace而不是push，防止在历史记录中保留当前页面
        // 这样用户就不能通过浏览器返回按钮返回到已登录状态
        this.$router.replace('/login');
      }).catch(() => {
        // 取消退出
        this.showDropdown = false;
      });
    },
    
    // 关闭下拉菜单
    closeDropdown() {
      this.showDropdown = false;
    },
    
    // 获取用户信息
    getUserInfo() {
      getUserProfile()
        .then(response => {
          if (response && response.success) {
            this.username = response.data.name || '未设置';
          }
        })
        .catch(error => {
          console.error('获取用户信息失败:', error);
        });
    }
  }
}
</script>

<style scoped>
.home-container {
  display: flex;
  height: 100vh;
  width: 100%;
}

/* 侧边栏样式 */
.sidebar {
  width: 269px;
  background-color: #f2f2f2;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow: hidden;
  z-index: 200;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  margin-bottom: -20px;
}

.logo {
  height: 60px;
  width: 240px;
}

/* 主区域样式 */
.main-area {
  flex: 1;
  margin-left: 269px; /* 与sidebar宽度一致 */
  display: flex;
  flex-direction: column;
  height: 100vh;
}

/* 头部样式 */
.header {
  height: 76px;
  background-color: #f2f2f2;
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 20px;
  width: 100%;
}

.current-nav {
  display: flex;
  align-items: center;
}

.current-nav h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
  font-weight: 500;
}

.user-info {
  display: flex;
  align-items: center;
  margin-left: auto; /* 确保user-info在右侧 */
  position: relative;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
}

.user-info:hover {
  background-color: #e5e5e5;
}

.avatar {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.username {
  color: #333;
  font-size: 16px;
}

/* 下拉菜单样式 */
.dropdown-menu {
  position: absolute;
  top: 55px;
  right: 0;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 120px;
}

.dropdown-item {
  padding: 10px 15px;
  display: flex;
  align-items: center;
  transition: background-color 0.3s;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.dropdown-item i {
  margin-right: 8px;
  color: #f56c6c;
}

.nav-menu {
  padding: 20px 0;
}

.nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 227px;
  height: 75px;
  color: #333;
  cursor: pointer;
  transition: background-color 0.3s;
  text-align: center;
  background-color: #fff;
  margin: 10px auto;
  border-radius: 4px;
}

.nav-item:hover,
.nav-item.active {
  background-color: #e5e5e5;
}

.nav-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  object-fit: contain;
}

/* 内容区域样式 */
.content {
  flex: 1;
  padding: 20px;
  text-align: left;
  overflow: auto;
}
</style>